<form (ngSubmit)="onFilterSubmit()" [formGroup]="filterForm">
	<div class="search-box">
		<input type="text" formControlName="keyword" class="form-control search" placeholder="Rechercher..." (keyup.enter)="onFilterSubmit()" />
		<i class="ri-search-line search-icon" style="cursor: pointer;" (click)="onFilterSubmit()"></i>
	</div>
</form>
